module.exports = __webpack_public_path__ + "img/appAsset-Branding--TemplateEmail-classic.3945e3b8.svg";